<template>
  <div
    v-if="category.priceList?.length"
    class="garage-price-list-category"
  >
    <div
      @click="expanded = !expanded"
      class="garage-price-list-category__header"
      :class="{ 'garage-price-list-category__header--expanded': expanded }"
    >
      <div class="garage-price-list-category__name">{{ category.name }}</div>
      <i
        class="i-arrow-down"
        :class="{ 'rotated-icon': expanded }"
      ></i>
    </div>

    <div
      v-if="expanded"
      class="garage-price-list-category__services"
    >
      <GaragePriceCategoryElement
        v-for="service in category.priceList"
        :popularCategory="category.id === popularCategoryId"
        :service="service"
        @show-service-details="emits('show-service-details', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PriceCategoryView, PriceElementView } from '~/api/docs/app';
import { popularCategoryId } from '~/models/consts';
import { useStore } from '~/store/store';

interface IProps {
  category: PriceCategoryView;
  currentFilter?: string | null;
}

interface IEmits {
  (name: 'set-other-reason-tab'): void;
  (name: 'show-service-details', value: PriceElementView): void;
}

// const and reactives
const expanded = ref(false);

// props
const props = defineProps<IProps>();

// emits
const emits = defineEmits<IEmits>();

// use 
const route = useRoute();
const store = useStore();

// watch
watch(() => props.currentFilter, () => {
  if (props.currentFilter !== popularCategoryId || props.category.id === popularCategoryId || store.contextAB) {
    expanded.value = true;
  }
}, {
  immediate: true
}
);

</script>

<style lang="scss" scoped>
@import url('assets/styles/components/garage-price-list-category.scss');
</style>